import { render } from "./TicketClosedTable.vue?vue&type=template&id=82858db6"
import script from "./TicketClosedTable.vue?vue&type=script&lang=js"
export * from "./TicketClosedTable.vue?vue&type=script&lang=js"

import "./TicketClosedTable.vue?vue&type=style&index=0&id=82858db6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__